// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App styles */
.app {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  background-color: #f0f2f5;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
}

/* Auth Modal styles */
.auth-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.auth-modal {
  background-color: white;
  padding: 2.5rem;
  border-radius: 24px;
  width: 100%;
  max-width: 450px;
  margin: 20px;
}

.auth-modal h2 {
  margin: 0 0 2.5rem 0;
  color: #000;
  font-size: 2.5rem;
  font-weight: 600;
  text-align: left;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.75rem;
  color: #000;
  font-weight: 500;
  font-size: 1.25rem;
}

.form-group input {
  width: 90%;
  padding: 1rem;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  background-color: #f8f9fa;
}

.form-group input:focus {
  outline: none;
  background-color: #f0f2f5;
}

.error-message {
  color: #dc3545;
  margin: 0.5rem 0;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.error-message::before {
  content: "⚠️";
}

/* Chat UI styles */
.chat-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  position: relative;
}

.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: linear-gradient(to bottom, #f8f9fa, #fff);
}

.message {
  max-width: 75%;
  padding: 0.8rem 1.2rem;
  border-radius: 1.2rem;
  margin: 0.3rem 0;
  position: relative;
  animation: messageSlide 0.3s ease-out;
}

@keyframes messageSlide {
  from { transform: translateY(10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.message.bot {
  align-self: flex-start;
  background-color: #f0f2f5;
  color: #1a1a1a;
  border-bottom-left-radius: 0.4rem;
}

.message.user {
  align-self: flex-end;
  background-color: #0084ff;
  color: white;
  border-bottom-right-radius: 0.4rem;
}

.message-content {
  line-height: 1.4;
  font-size: 0.95rem;
}

.chat-input-form {
  display: flex;
  padding: 1rem 1.5rem;
  background-color: #fff;
  border-top: 1px solid #e1e1e1;
  gap: 0.75rem;
  align-items: flex-start;
  position: relative;
}

.chat-input {
  flex: 1 1;
  padding: 0.875rem 1.25rem;
  border: 2px solid #e1e1e1;
  border-radius: 24px;
  font-size: 0.95rem;
  min-width: 0;
  transition: all 0.2s ease;
  background-color: #f8f9fa;
  resize: none;
  max-height: 150px;
  min-height: 24px;
  line-height: 1.5;
  overflow-y: auto;
}

.chat-input:focus {
  outline: none;
  border-color: #2196f3;
  background-color: #fff;
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);
}

.send-button {
  padding: 0.875rem 1.5rem;
  background-color: #0084ff;
  color: white;
  border: none;
  border-radius: 24px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
  min-width: 100px;
  height: 45px;
  white-space: nowrap;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  align-self: flex-start;
}

.send-button::after {
  content: "→";
  font-size: 1.2rem;
}

.send-button:hover {
  background-color: #0073e6;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 132, 255, 0.3);
}

.send-button:active {
  transform: translateY(0);
}

/* Login button style */
.auth-modal button {
  padding: 1rem;
  background-color: #0066ff;
  color: white;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 1.25rem;
  font-weight: 500;
  width: 100%;
  margin-top: 2rem;
  transition: background-color 0.2s ease;
}

.auth-modal button:hover {
  background-color: #0052cc;
}

/* Scrollbar styling */
.chat-messages::-webkit-scrollbar {
  width: 6px;
}

.chat-messages::-webkit-scrollbar-track {
  background: transparent;
}

.chat-messages::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.3);
}

/* Chat Header styles */
.chat-header {
  padding: 1rem 1.5rem;
  background-color: #fff;
  border-bottom: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.chat-header h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a1a1a;
}

.clear-chat-button {
  padding: 0.5rem 1rem;
  background-color: #f0f2f5;
  color: #1a1a1a;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.clear-chat-button:hover {
  background-color: #e4e6eb;
}

.online-indicator {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  color: #2e7d32;
  gap: 0.5rem;
}

.online-indicator::before {
  content: "";
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #2e7d32;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

/* Message timestamp */
.message-timestamp {
  display: block;
  font-size: 0.75rem;
  margin-top: 0.25rem;
  opacity: 0.7;
}

.message.user .message-timestamp {
  text-align: right;
}

/* Typing indicator */
.typing-indicator {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.5rem 1rem;
}

.typing-indicator span {
  width: 8px;
  height: 8px;
  background-color: #90a4ae;
  border-radius: 50%;
  display: inline-block;
  animation: bounce 1.4s infinite ease-in-out;
}

.typing-indicator span:nth-child(1) {
  animation-delay: -0.32s;
}

.typing-indicator span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounce {
  0%, 80%, 100% { transform: scale(0); }
  40% { transform: scale(1); }
}

/* Disabled button state */
.send-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* Loading indicator styles */
.loading-indicator {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #0084ff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-indicator span {
  color: #666;
  font-size: 0.9rem;
}

/* Markdown message styles */
.message-content {
  width: 100%;
}

.message.bot .message-content > * {
  margin: 0.5rem 0;
}

.message.bot .message-content > *:first-child {
  margin-top: 0;
}

.message.bot .message-content > *:last-child {
  margin-bottom: 0;
}

.message.bot .message-content h1,
.message.bot .message-content h2,
.message.bot .message-content h3,
.message.bot .message-content h4,
.message.bot .message-content h5,
.message.bot .message-content h6 {
  font-weight: 600;
  line-height: 1.3;
  margin: 1rem 0 0.5rem;
}

.message.bot .message-content p {
  margin: 0.5rem 0;
  line-height: 1.5;
}

.message.bot .message-content ul,
.message.bot .message-content ol {
  margin: 0.5rem 0;
  padding-left: 1.5rem;
}

.message.bot .message-content li {
  margin: 0.25rem 0;
}

.message.bot .message-content a {
  color: #0084ff;
  text-decoration: none;
}

.message.bot .message-content a:hover {
  text-decoration: underline;
}

.message.bot .message-content code {
  background-color: rgba(0, 0, 0, 0.05);
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  font-size: 0.9em;
}

.message.bot .message-content pre {
  background-color: #f6f8fa;
  padding: 1rem;
  border-radius: 8px;
  overflow-x: auto;
}

.message.bot .message-content blockquote {
  border-left: 4px solid #e1e4e8;
  margin: 0.5rem 0;
  padding-left: 1rem;
  color: #666;
}

.message.bot .message-content hr {
  border: none;
  border-top: 1px solid #e1e4e8;
  margin: 1rem 0;
}

/* Disabled input styles */
.chat-input:disabled {
  background-color: #f0f2f5;
  cursor: not-allowed;
}

/* Header buttons */
.header-buttons {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.settings-button {
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  color: #666;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.settings-button:hover {
  background-color: #f0f2f5;
  color: #1a1a1a;
}

/* Settings Modal */
.settings-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.settings-modal {
  background-color: white;
  padding: 2rem;
  border-radius: 24px;
  width: 100%;
  max-width: 500px;
  margin: 20px;
}

.settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.settings-header h2 {
  margin: 0;
  font-size: 2rem;
  font-weight: 600;
  color: #000;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #666;
  cursor: pointer;
  padding: 0.5rem;
  width: auto;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.settings-modal .form-group {
  margin-bottom: 2rem;
}

.settings-modal .form-group label {
  display: block;
  margin-bottom: 1rem;
  color: #000;
  font-weight: 500;
  font-size: 1.25rem;
}

.settings-modal textarea {
  width: 94%;
  padding: 1rem;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  background-color: #f8f9fa;
  resize: none;
  height: 100px;
  font-family: inherit;
}

.settings-modal textarea:focus {
  outline: none;
  background-color: #f0f2f5;
}

.settings-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
}

.cancel-button {
  padding: 0.875rem 1.5rem;
  background-color: #f0f2f5;
  color: #000;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  min-width: 120px;
  transition: all 0.2s ease;
}

.save-button {
  padding: 0.875rem 1.5rem;
  background-color: #0066ff;
  color: white;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  min-width: 120px;
  transition: all 0.2s ease;
}

.cancel-button:hover {
  background-color: #e4e6eb;
}

.save-button:hover {
  background-color: #0052cc;
} `, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,yGAAyG;AAC3G;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qDAAqD;AACvD;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,sBAAsB;EACtB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE;AACrB;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB,mBAAmB,EAAE;EACrC,MAAM,mBAAmB,EAAE;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* App styles */\n.app {\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  flex-direction: column;\n  background-color: #f0f2f5;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n}\n\n/* Auth Modal styles */\n.auth-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.auth-modal {\n  background-color: white;\n  padding: 2.5rem;\n  border-radius: 24px;\n  width: 100%;\n  max-width: 450px;\n  margin: 20px;\n}\n\n.auth-modal h2 {\n  margin: 0 0 2.5rem 0;\n  color: #000;\n  font-size: 2.5rem;\n  font-weight: 600;\n  text-align: left;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.75rem;\n  color: #000;\n  font-weight: 500;\n  font-size: 1.25rem;\n}\n\n.form-group input {\n  width: 90%;\n  padding: 1rem;\n  border: none;\n  border-radius: 12px;\n  font-size: 1rem;\n  background-color: #f8f9fa;\n}\n\n.form-group input:focus {\n  outline: none;\n  background-color: #f0f2f5;\n}\n\n.error-message {\n  color: #dc3545;\n  margin: 0.5rem 0;\n  font-size: 0.875rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.error-message::before {\n  content: \"⚠️\";\n}\n\n/* Chat UI styles */\n.chat-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background-color: #fff;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);\n  position: relative;\n}\n\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  background: linear-gradient(to bottom, #f8f9fa, #fff);\n}\n\n.message {\n  max-width: 75%;\n  padding: 0.8rem 1.2rem;\n  border-radius: 1.2rem;\n  margin: 0.3rem 0;\n  position: relative;\n  animation: messageSlide 0.3s ease-out;\n}\n\n@keyframes messageSlide {\n  from { transform: translateY(10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.message.bot {\n  align-self: flex-start;\n  background-color: #f0f2f5;\n  color: #1a1a1a;\n  border-bottom-left-radius: 0.4rem;\n}\n\n.message.user {\n  align-self: flex-end;\n  background-color: #0084ff;\n  color: white;\n  border-bottom-right-radius: 0.4rem;\n}\n\n.message-content {\n  line-height: 1.4;\n  font-size: 0.95rem;\n}\n\n.chat-input-form {\n  display: flex;\n  padding: 1rem 1.5rem;\n  background-color: #fff;\n  border-top: 1px solid #e1e1e1;\n  gap: 0.75rem;\n  align-items: flex-start;\n  position: relative;\n}\n\n.chat-input {\n  flex: 1;\n  padding: 0.875rem 1.25rem;\n  border: 2px solid #e1e1e1;\n  border-radius: 24px;\n  font-size: 0.95rem;\n  min-width: 0;\n  transition: all 0.2s ease;\n  background-color: #f8f9fa;\n  resize: none;\n  max-height: 150px;\n  min-height: 24px;\n  line-height: 1.5;\n  overflow-y: auto;\n}\n\n.chat-input:focus {\n  outline: none;\n  border-color: #2196f3;\n  background-color: #fff;\n  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);\n}\n\n.send-button {\n  padding: 0.875rem 1.5rem;\n  background-color: #0084ff;\n  color: white;\n  border: none;\n  border-radius: 24px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 600;\n  min-width: 100px;\n  height: 45px;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  align-self: flex-start;\n}\n\n.send-button::after {\n  content: \"→\";\n  font-size: 1.2rem;\n}\n\n.send-button:hover {\n  background-color: #0073e6;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 132, 255, 0.3);\n}\n\n.send-button:active {\n  transform: translateY(0);\n}\n\n/* Login button style */\n.auth-modal button {\n  padding: 1rem;\n  background-color: #0066ff;\n  color: white;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  font-size: 1.25rem;\n  font-weight: 500;\n  width: 100%;\n  margin-top: 2rem;\n  transition: background-color 0.2s ease;\n}\n\n.auth-modal button:hover {\n  background-color: #0052cc;\n}\n\n/* Scrollbar styling */\n.chat-messages::-webkit-scrollbar {\n  width: 6px;\n}\n\n.chat-messages::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.chat-messages::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-radius: 3px;\n}\n\n.chat-messages::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(0, 0, 0, 0.3);\n}\n\n/* Chat Header styles */\n.chat-header {\n  padding: 1rem 1.5rem;\n  background-color: #fff;\n  border-bottom: 1px solid #e1e1e1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.chat-header h2 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.clear-chat-button {\n  padding: 0.5rem 1rem;\n  background-color: #f0f2f5;\n  color: #1a1a1a;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.clear-chat-button:hover {\n  background-color: #e4e6eb;\n}\n\n.online-indicator {\n  display: flex;\n  align-items: center;\n  font-size: 0.875rem;\n  color: #2e7d32;\n  gap: 0.5rem;\n}\n\n.online-indicator::before {\n  content: \"\";\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  background-color: #2e7d32;\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% { opacity: 1; }\n  50% { opacity: 0.5; }\n  100% { opacity: 1; }\n}\n\n/* Message timestamp */\n.message-timestamp {\n  display: block;\n  font-size: 0.75rem;\n  margin-top: 0.25rem;\n  opacity: 0.7;\n}\n\n.message.user .message-timestamp {\n  text-align: right;\n}\n\n/* Typing indicator */\n.typing-indicator {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.5rem 1rem;\n}\n\n.typing-indicator span {\n  width: 8px;\n  height: 8px;\n  background-color: #90a4ae;\n  border-radius: 50%;\n  display: inline-block;\n  animation: bounce 1.4s infinite ease-in-out;\n}\n\n.typing-indicator span:nth-child(1) {\n  animation-delay: -0.32s;\n}\n\n.typing-indicator span:nth-child(2) {\n  animation-delay: -0.16s;\n}\n\n@keyframes bounce {\n  0%, 80%, 100% { transform: scale(0); }\n  40% { transform: scale(1); }\n}\n\n/* Disabled button state */\n.send-button:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* Loading indicator styles */\n.loading-indicator {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.5rem;\n}\n\n.loading-spinner {\n  width: 20px;\n  height: 20px;\n  border: 3px solid #f3f3f3;\n  border-top: 3px solid #0084ff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-indicator span {\n  color: #666;\n  font-size: 0.9rem;\n}\n\n/* Markdown message styles */\n.message-content {\n  width: 100%;\n}\n\n.message.bot .message-content > * {\n  margin: 0.5rem 0;\n}\n\n.message.bot .message-content > *:first-child {\n  margin-top: 0;\n}\n\n.message.bot .message-content > *:last-child {\n  margin-bottom: 0;\n}\n\n.message.bot .message-content h1,\n.message.bot .message-content h2,\n.message.bot .message-content h3,\n.message.bot .message-content h4,\n.message.bot .message-content h5,\n.message.bot .message-content h6 {\n  font-weight: 600;\n  line-height: 1.3;\n  margin: 1rem 0 0.5rem;\n}\n\n.message.bot .message-content p {\n  margin: 0.5rem 0;\n  line-height: 1.5;\n}\n\n.message.bot .message-content ul,\n.message.bot .message-content ol {\n  margin: 0.5rem 0;\n  padding-left: 1.5rem;\n}\n\n.message.bot .message-content li {\n  margin: 0.25rem 0;\n}\n\n.message.bot .message-content a {\n  color: #0084ff;\n  text-decoration: none;\n}\n\n.message.bot .message-content a:hover {\n  text-decoration: underline;\n}\n\n.message.bot .message-content code {\n  background-color: rgba(0, 0, 0, 0.05);\n  padding: 0.2rem 0.4rem;\n  border-radius: 4px;\n  font-size: 0.9em;\n}\n\n.message.bot .message-content pre {\n  background-color: #f6f8fa;\n  padding: 1rem;\n  border-radius: 8px;\n  overflow-x: auto;\n}\n\n.message.bot .message-content blockquote {\n  border-left: 4px solid #e1e4e8;\n  margin: 0.5rem 0;\n  padding-left: 1rem;\n  color: #666;\n}\n\n.message.bot .message-content hr {\n  border: none;\n  border-top: 1px solid #e1e4e8;\n  margin: 1rem 0;\n}\n\n/* Disabled input styles */\n.chat-input:disabled {\n  background-color: #f0f2f5;\n  cursor: not-allowed;\n}\n\n/* Header buttons */\n.header-buttons {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.settings-button {\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  cursor: pointer;\n  color: #666;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.settings-button:hover {\n  background-color: #f0f2f5;\n  color: #1a1a1a;\n}\n\n/* Settings Modal */\n.settings-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.settings-modal {\n  background-color: white;\n  padding: 2rem;\n  border-radius: 24px;\n  width: 100%;\n  max-width: 500px;\n  margin: 20px;\n}\n\n.settings-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.settings-header h2 {\n  margin: 0;\n  font-size: 2rem;\n  font-weight: 600;\n  color: #000;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #666;\n  cursor: pointer;\n  padding: 0.5rem;\n  width: auto;\n  height: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.settings-modal .form-group {\n  margin-bottom: 2rem;\n}\n\n.settings-modal .form-group label {\n  display: block;\n  margin-bottom: 1rem;\n  color: #000;\n  font-weight: 500;\n  font-size: 1.25rem;\n}\n\n.settings-modal textarea {\n  width: 94%;\n  padding: 1rem;\n  border: none;\n  border-radius: 12px;\n  font-size: 1rem;\n  background-color: #f8f9fa;\n  resize: none;\n  height: 100px;\n  font-family: inherit;\n}\n\n.settings-modal textarea:focus {\n  outline: none;\n  background-color: #f0f2f5;\n}\n\n.settings-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.cancel-button {\n  padding: 0.875rem 1.5rem;\n  background-color: #f0f2f5;\n  color: #000;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 500;\n  min-width: 120px;\n  transition: all 0.2s ease;\n}\n\n.save-button {\n  padding: 0.875rem 1.5rem;\n  background-color: #0066ff;\n  color: white;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 500;\n  min-width: 120px;\n  transition: all 0.2s ease;\n}\n\n.cancel-button:hover {\n  background-color: #e4e6eb;\n}\n\n.save-button:hover {\n  background-color: #0052cc;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
